var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { createPortal } from "react-dom";
import Text from "./text";
import { useDesignTokens } from "../lib/design-tokens";
var OFFSET = 12;
var Tooltip = function (_a) {
    var children = _a.children, style = _a.style, content = _a.content, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    var designTokens = useDesignTokens();
    var _c = useState(null), pos = _c[0], setPos = _c[1];
    var handleMouseMove = function (e) {
        setPos({ x: e.clientX, y: e.clientY, nearRight: e.clientX + 280 > window.innerWidth });
    };
    var handleMouseLeave = function () { return setPos(null); };
    var visible = pos !== null && enabled && content !== undefined;
    return (_jsxs(_Fragment, { children: [_jsx("span", { onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave, style: style, children: children }), visible && pos && createPortal(_jsx("div", { style: __assign(__assign({ position: "fixed", top: pos.y - OFFSET }, (pos.nearRight
                    ? { right: window.innerWidth - pos.x + OFFSET, left: "auto" }
                    : { left: pos.x + OFFSET })), { transform: "translateY(-100%)", backgroundColor: designTokens.colors.surface.White, borderRadius: 8, padding: 16, maxWidth: 256, zIndex: 9999, pointerEvents: "none", boxShadow: "0px 6px 20px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.16)" }), children: typeof content === "string" ? (_jsx(Text, { textStyle: "body", children: content })) : (content) }), document.body)] }));
};
export default Tooltip;
